import React, { useEffect, useState } from 'react';
import useFetch from 'core/hooks/api/useFetch';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';

const FaqV1 = () => {
    const { data: faqs, loading, error } = useFetch(API_ENDPOINTS.FAQ);
    const [expandedFaqs, setExpandedFaqs] = useState([]);

    useEffect(() => {
        if (faqs) {
            const initialFaqs = faqs.map((faq, index) => ({
                ...faq,
                isOpen: index === 0 // Start with the first item expanded
            }));
            setExpandedFaqs(initialFaqs);
        }
    }, [faqs]);

    const toggleFaq = (index) => {
        setExpandedFaqs(expandedFaqs.map((faq, i) => ({
            ...faq,
            isOpen: i === index ? !faq.isOpen : false // Only allow one item to be expanded at a time
        })));
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <div className="ltn__faq-area mb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ltn__faq-inner ltn__faq-inner-2">
                            <div id="accordion_2">
                                {expandedFaqs.map((faq, index) => (
                                    <div className="card" key={index}>
                                        <h6 className={`ltn__card-title ${faq.isOpen ? '' : 'collapsed'}`} onClick={() => toggleFaq(index)}>
                                            {faq.question}
                                        </h6>
                                        <div className={`collapse ${faq.isOpen ? 'show' : ''}`} style={{ transition: 'height 0.3s ease' }}>
                                            <div className="card-body">
                                                <p>{faq.answer}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FaqV1;